import { css, html } from "lit";
import { queryAssignedElements } from "@lit/reactive-element/decorators/query-assigned-elements.js";
import { DsfToggleButton } from "../ToggleButton/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const navigationKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", " "];
let DsfToggleButtonGroup = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_deselect = false;
  }
  syncSelectedState() {
    this.toggleButtonElements.forEach((el) => el.setChecked(el.value === this.value));
  }
  handleSlotInput(ev) {
    if (!ev.target || !(ev.target instanceof DsfToggleButton)) {
      return;
    }
    const toggleButton = ev.target;
    if (toggleButton.value !== this.value) {
      this.setValue(toggleButton.value);
    }
  }
  handleSlotUpdate() {
    this.syncSelectedState();
  }
  handleSlotClick(ev) {
    if (!ev.target || !(ev.target instanceof DsfToggleButton)) {
      return;
    }
    this.handleDeselect(ev.target, ev);
  }
  handleKeyDown(ev) {
    const key = ev.key;
    if (!navigationKeys.includes(key)) {
      return;
    }
    const toggleButtons = [...this.toggleButtonElements];
    if (!toggleButtons) {
      return;
    }
    const focusedButton = toggleButtons.find((r) => r === document.activeElement) || toggleButtons[0];
    if (key === " ") {
      this.handleDeselect(focusedButton, ev);
      return;
    }
    ev.preventDefault();
    const indexIncrement = key === "ArrowDown" || key === "ArrowRight" ? 1 : -1;
    let nextIndex = toggleButtons.indexOf(focusedButton) + indexIncrement;
    if (nextIndex < 0) {
      nextIndex = toggleButtons.length - 1;
    }
    if (nextIndex > toggleButtons.length - 1) {
      nextIndex = 0;
    }
    toggleButtons[nextIndex].focus();
  }
  /**
   * Handle deselect functionality. Because native <input type="radio"> doesn't support deselect (by bot mouse clicks and keyboard),
   * manual handling and preventDefault are required.
   */
  handleDeselect(toggleButton, userEvent) {
    if (this.dsf_deselect && toggleButton.value === this.value) {
      this.setValue(void 0);
      userEvent.preventDefault();
    }
  }
  setValue(value) {
    this.value = value;
    this.emit({ name: "input", payload: this.value });
    this.emit({ name: "change", payload: this.value });
  }
  update(changedProps) {
    if (changedProps.has("value")) {
      this.syncSelectedState();
    }
    super.update(changedProps);
  }
  render() {
    return html`
      <slot
        class="flex flex-auto flex-row gap-4 rounded-m border border-neutral-100 p-4"
        @slotchange=${this.handleSlotUpdate}
        @click=${this.handleSlotClick}
        @input=${this.handleSlotInput}
        @keydown=${this.handleKeyDown}
      >
      </slot>
    `;
  }
};
DsfToggleButtonGroup.styles = [
  ...BaseComponent.styles,
  css`
      ::slotted(*) {
        flex: 1 1 0%;
      }
    `
];
__decorateClass([
  prop({ type: String })
], DsfToggleButtonGroup.prototype, "value", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfToggleButtonGroup.prototype, "dsf_deselect", 2);
__decorateClass([
  queryAssignedElements({ selector: "dsf-toggle-button" })
], DsfToggleButtonGroup.prototype, "toggleButtonElements", 2);
__decorateClass([
  preventDefault
], DsfToggleButtonGroup.prototype, "handleSlotInput", 1);
DsfToggleButtonGroup = __decorateClass([
  defineElement("dsf-toggle-button-group")
], DsfToggleButtonGroup);
export {
  DsfToggleButtonGroup
};
